const theme = {
  initialColorMode: 'system',
  useSystemColorMode: true,
  fonts: {
    heading: 'Inter, sans-serif',
    body: 'Inter, sans-serif',
  },
};

export default theme;
